export default __webpack_public_path__ + "static/media/prints_front.9242ea8d.png";